import type { NeonProvisionResult, VercelRunner } from '@cli-types/next-adapter/vercel.js'
import { provisionNeonInteractive } from '../neon/provision-neon-interactive.js'
import { provisionNeon } from '../neon/provision-neon.js'

export function provisionNeonForMode(
  runner: VercelRunner,
  options: { cwd: string; interactive: boolean; plan?: string; env?: NodeJS.ProcessEnv }
): Promise<NeonProvisionResult> {
  const opts = { plan: options.plan, env: options.env }
  return options.interactive
    ? provisionNeonInteractive(runner, options.cwd, opts)
    : provisionNeon(runner, options.cwd, opts)
}
